import { UserService } from 'src/app/_services/user.service';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { GlobalService } from 'src/app/_services/global.service';
import { BusinessSetupService } from 'src/app/_services/business-setup.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-theme-edit',
  templateUrl: './theme-edit.component.html',
  styleUrls: ['./theme-edit.component.scss']
})
export class ThemeEditComponent implements OnInit {
  _global = GlobalService;
  @ViewChild('iframe') iframeElement!: ElementRef<HTMLIFrameElement>;;
  isLoaded:boolean = true; 
  webUrl:SafeResourceUrl;

  constructor(
    public _abd: AppBaseDataService,
    public _businessSetup: BusinessSetupService,
    public _userService: UserService,
    private sanitizer: DomSanitizer
  ){}

  ngOnInit(): void {

   if(this._global.webStoreConfiguration !== null){
      this.webUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this._global.webStoreConfiguration?.demoUrl)    
      }

  }

}
